import {setReactiveStateValue} from "@/helperFunctions";

export const setFacebookId = (state, id) => {
	state.fbID = id
};

export const setGuideState = (state, value) => {
	state.states.guide = value
};

export const setRouteReferrerName = (state, value) => {
	state.routeReferrerName = value
};

export const setUniversX = (state, value) => {
	state.univers.x = value
};

export const setUniversY = (state, value) => {
	state.univers.y = value
};

export const setUniversScale = (state, value) => {
	state.univers.scale = value
};

export const handleMetaEvent = (state,event) => {
	if(event === 'lavetEtKoeb')
	{
		state.metaEvents.lavetEtKoeb++;
	}
	else if(event === 'gangIOelTeltet')
	{
		state.metaEvents.gangIOelTeltet = true;
	}
}

export const setSystemSettings = (state, settings) => {
	const keys = Object.keys(settings);
	for(let i = 0; i < keys.length; i++){
		setReactiveStateValue(state.systemSettings,keys[i],settings[keys[i]])
	}
}

export const setHasSeenWelcomeScreen = (state, value) => {
	state.hasSeenWelcomeScreen = value
};

export const setLastSentWuhuu = (state, ts) => {
	state.lastSentWuhuu = ts;
}

export const setShowTshirtPopup = (state, value) => {
	state.showTshirtPopup = value;
}
